import React, {Component} from 'react'
import IgniteDataTable from '../../common/datatable'
import {history} from "../../../store";
import {dateTimeFormat} from '../../../utils/commonFunctions'

class OrdersList extends Component {
  constructor(props){
    super(props);
  }

  render() {
    const columns = [
      {prop: 'created_at', title: 'Order date', format(data, row) {return <b>{dateTimeFormat(data)}</b>}},
      {prop: 'order_type', title: 'Order type'},
      {prop: 'order_number', title: 'Order number'},
      {prop: 'your_reference', title: 'Reference'},
      {prop: 'outlet', title: 'Customer number'},
      {prop: 'user_id', title: 'User id', onClick: (cell, row) => {
        history.push(`/admin/users/${row.attributes.user_id}/details`);
      }},
      {prop: 'status', title: 'Order status'},
      {
        prop: 'sent_to_ituk',
        title: 'Sent to Imperial Brands',
        format(data, row) {
          return <b>{dateTimeFormat(data)}</b>
        }
      },
      {prop: 'invoice_received', title: 'Invoice Received', format(data, row) {return <b>{dateTimeFormat(data)}</b>}},
      {prop: 'order_total', title: 'Order Value'},

    ];

    return (
      <IgniteDataTable
        data={this.props.orders}
        hasAttributes={true}
        columns={columns}
        pagination={true}
      />
    )
  }
}

export default OrdersList


// WEBPACK FOOTER //
// ./src/components/admin/orders/orders-list.jsx